import { Home } from '@mui/icons-material';
import { Box, Breadcrumbs, Container, Typography } from '@mui/material';
import { FC, useEffect } from 'react';
import { DocumentsDataGrid } from './DocumentsDataGrid';
import { useAppDispatch, useAppSelector } from '@src/app/hooks/store';
import { ScreenState } from '@src/app/enums';
import { getDocumentsAsync } from '@src/app/store/reducers/documents/thunks';
import { selectDocuments } from '@src/app/store/reducers/documents/selectors';
import { selectPortfolios } from '@src/app/store/reducers/portfolios/selectors';
import { useWindow } from '@src/app/hooks/useWindow';
import { useAppContext } from '@src/app/hooks/useAppContext';
import { useHistory } from 'react-router';
import { homeUrl } from '@src/app/utils/UrlBuilder';
import { PageContent, PortfolioSelection } from '@components/index';

const Documents: FC = (): JSX.Element => {
  const { clientAccounts } = useAppSelector(selectPortfolios);
  const { portfoliosKeysSelected, portfolioInfoState } = useAppSelector(selectPortfolios);
  const { state, data } = useAppSelector(selectDocuments);
  const { transitioningMenu } = useAppContext();
  const { resizing } = useWindow();
  const history = useHistory();
  const dispatch = useAppDispatch();

  const fetchDocumentsAsync = async () => {
    dispatch(getDocumentsAsync({ clientAccounts: clientAccounts, portfolioKeys: portfoliosKeysSelected }));
  };

  useEffect(() => {
    fetchDocumentsAsync();
  }, [clientAccounts, portfoliosKeysSelected]);

  return (
    <Container maxWidth={false}>
      <Box display="flex" flexDirection="column" gap="24px" mb={6}>
        <Box display="flex" alignItems="center" gap="16px" mt={2}>
          <Breadcrumbs>
            <Typography
              onClick={() => history.push(homeUrl())}
              sx={{
                display: 'flex',
                alignItems: 'center',
                ':hover': {
                  cursor: 'pointer',
                },
              }}
              color="inherit"
            >
              <Home sx={{ mr: 0.5 }} fontSize="small" />
              Dashboard
            </Typography>
            <Typography fontWeight={600} fontSize="20px" color="#222222">
              Documents
            </Typography>
          </Breadcrumbs>
          <Box flex={1} />

          <PortfolioSelection allowCombining={false} disabled={state === ScreenState.Loading || portfolioInfoState === ScreenState.Loading} />
        </Box>

        <Typography sx={{ color: '#222222' }}>Documents related to your account.</Typography>

        <PageContent isLoading={state === ScreenState.Loading || portfolioInfoState === ScreenState.Loading}>
          {!resizing && !transitioningMenu && <DocumentsDataGrid data={data || []} isLoading={state === ScreenState.Loading} />}
        </PageContent>
      </Box>
    </Container>
  );
};

export default Documents;
